import PageNotFound from './404.vue'
export default PageNotFound